import React from 'react';
import { Outlet } from 'react-router-dom';

const CabsLayout = () => (
  <section className="min-h-[60vh] bg-[linear-gradient(180deg,#f7faf9_0%,#f5f1e8_100%)]">
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-14">
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">Oxitaxi Cabs</p>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  </section>
);

export default CabsLayout;
